module.exports = __webpack_public_path__ + "img/b3a.f2e04d74.jpg";